const pricing = [
  {
    id: 1,
    title: "Silver Package",
    price: "$199.00",
    particleId: "price-p1",
    unavailable: [3, 4],
    features: [
      "30 Days Trial Features",
      "Unlimited Features",
      "Multi-Language Content",
      "Data backup and recovery",
      "Synced To Cloud Database",
    ],
  },
  {
    id: 2,
    title: "Gold Package",
    price: "$299.00",
    particleId: "price-p2",
    unavailable: [4],
    features: [
      "30 Days Trial Features",
      "Unlimited Features",
      "Multi-Language Content",
      "Data backup and recovery",
      "Synced To Cloud Database",
    ],
  },
  {
    id: 3,
    title: "Platinum Package",
    price: "$599.00",
    particleId: "price-p3",
    unavailable: [],
    features: [
      "30 Days Trial Features",
      "Unlimited Features",
      "Multi-Language Content",
      "Data backup and recovery",
      "Synced To Cloud Database",
    ],
  },
];

export default pricing;
